module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"form_error":{"title":"There was an error with your submission","message":"\\"{label}\\" {message}"}},"ja":{"form_error":{"title":"フォームはまだ送信されていません","message":"「{label}」{message}"}}}')
  delete Component.options._Ctor
}
